export enum EAuthorizationItemType {
    UserGroup = 0,
    Role = 1,
    Stakeholder = 2
}

export enum EAuthorizationPermissionType {
    FullControl = 0,
    ViewData = 1,
    Create = 2,
    Delete = 3,
    Modify = 4,
    Use = 5,
    NewCase = 6,
    Manage = 7,
    Export = 8,
    Analize = 9,
    Analysis = 10
}

export enum EAuthorizationPermissionStatus {
    Deny = 0,
    Allow = 1,
    None = 2
}

export enum ESortOrderType {
    asc = 0,
    desc = 1,
    none = 2
}
